export * from "./constants";
export * from "./types/dashboard";

/**
 * Aliases for the vendored names that collide with types the Hub already
 * exports - `Dashboard` (`@/types/dashboards`), `Database`
 * (`@/features/supabase`), `Field` (`@/types/hubspot`) and `Table`
 * (`@/features/editor`). Import these when both are in scope; otherwise the
 * verbatim Metabase names above are fine.
 */
export type {
  Dashboard as MetabaseDashboard,
  DashboardCard as MetabaseDashboardCard,
  Database as MetabaseDatabase,
  Field as MetabaseField,
  Table as MetabaseTable,
} from "./types/dashboard";
